// extracted by mini-css-extract-plugin
export default {"testModel":"Predict_testModel__0r6JS","sectionHeader":"Predict_sectionHeader__-lh7i","layout":"Predict_layout__xNbG8"};